var _mask, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 7,
    maskUnits: "userSpaceOnUse",
    width: 7,
    x: 9,
    y: 1
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m9.56836 1.33203h5.69264v5.68854h-5.69264z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m14.7608 7.02057c-.2513 0-.4673-.18866-.496-.444-.2526-2.25066-2.0006-3.99733-4.252-4.24733-.27398-.03067-.47198-.27733-.44131-.552.03-.274.27467-.476.55201-.44133 2.7187.302 4.83 2.41066 5.1347 5.12866.0306.27467-.1667.522-.4407.55267-.0187.002-.038.00333-.0567.00333z",
    fill: "#ED9645",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#ED9645",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.401 7.02878c-.2347 0-.4434-.16533-.49-.404-.192-.98666-.9527-1.74733-1.93802-1.93866-.27133-.05267-.448-.31467-.39533-.586.05266-.27134.31933-.44867.58595-.39534 1.3874.26934 2.4587 1.34 2.7287 2.728.0527.272-.124.534-.3947.58667-.0326.006-.0646.00933-.0966.00933z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.19313 2.72393.04837-.05054c1.28494-1.28507 2.12171-1.62568 3.01453-1.11228.25682.14769.49759.35441.82498.68693l1.00425 1.04135c.55468.60526.68078 1.18583.50017 1.86574l-.02489.09001-.02761.0895-.13426.39389c-.28734.88332-.16737 1.38169.85496 2.40376 1.06313 1.06286 1.55939 1.14981 2.51087.81733l.1696-.05894.205-.06659.0897-.02491c.7227-.19281 1.3332-.03895 1.9806.60806l.8092.78156.2382.2343c.2641.2693.4386.4827.5675.7082.5102.8925.1692 1.7288-1.1528 3.0459l-.1257.1274c-.1974.1902-.3818.3265-.6527.4552-.4548.2159-.992.2973-1.6163.2105-1.53833-.214-3.48937-1.4277-5.96156-3.8993-.20124-.2012-.39399-.3985-.57842-.592l-.35785-.3819c-3.35324-3.64317-3.64906-5.88115-2.27487-7.28473zm3.07846.12872c-.21719-.21413-.37497-.34466-.51406-.42465-.30768-.17693-.63988-.10214-1.25468.42701l-.19318.17258c-.0337.03111-.06816.0634-.10343.0969l-.22152.21575-.01996.02494-.15017.15087c-.3629.37068-.5348.82307-.38667 1.60109.24307 1.27669 1.35568 3.00858 3.59433 5.24666 2.33259 2.332 4.10985 3.4376 5.39225 3.616.7476.104 1.129-.0771 1.5178-.4755l.2966-.2993c.1391-.1455.2579-.2774.3582-.3979l.1369-.1725c.3498-.4659.3817-.7454.2321-1.0071-.0569-.0995-.1397-.2087-.2602-.3421l-.1635-.1727-.0967-.0968-1.0209-.9857c-.3411-.31462-.5742-.35925-.9282-.26482l-.1022.02939-.4228.14355c-1.22676.39618-2.11175.20408-3.41499-1.09884-1.34976-1.34942-1.50806-2.25053-1.05581-3.548l.02901-.08338.08023-.24171.03943-.15407c.06994-.33531-.00991-.56911-.37036-.92962l-.04948-.04987z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallus);
export default __webpack_public_path__ + "static/media/callus.72bdde2dfa85bdb54ffb14d4685e27ae.svg";
export { ForwardRef as ReactComponent };